<template>
  <span aria-hidden="true" class="bg-grey-300 inline-block animate-pulse dark:bg-white/15" :class="rounded === 'full' ? 'rounded-full' : 'rounded'" />
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    /** `full` for pill/chip placeholders; default matches text lines. */
    rounded?: 'md' | 'full'
  }>(),
  { rounded: 'md' },
)
</script>
